// kpssskapi/data/turkish/hierarchy.ts
// KPSS Türkçe Ders Notları ve RAG Müfredat Hiyerarşisi (ÖSYM & Soru Bankası Senkronlu)

export interface TurkishHierarchyUnit {
    id: string;
    unitNumber: number;
    label: string;
    title: string;
    icon: string;
    subTopics: string[];
    description?: string;
}

export const TURKISH_HIERARCHY: TurkishHierarchyUnit[] = [
    {
        id: 'tur_u1',
        unitNumber: 1,
        label: '1. ÜNİTE: DİL BİLGİSİ',
        title: 'Dil Bilgisi',
        icon: '🔤',
        description: 'Yapı Bilgisi, Sözcük Türleri, Cümlenin Ögeleri, Cümle Çeşitleri ve Çatı Bilgisi',
        subTopics: [
            'Yapı Bilgisi (Kök, Ek ve Sözcüğün Yapısı)',
            'Sözcük Türleri (İsim, Sıfat, Zamir, Zarf)',
            'Sözcük Türleri (Edat, Bağlaç, Ünlem, Fiil, Ek Fiil, Fiilimsi)',
            'Cümlenin Ögeleri',
            'Cümle Çeşitleri (Cümle Türleri)',
            'Çatı Bilgisi (Fiilde Çatı)'
        ]
    },
    {
        id: 'tur_u2',
        unitNumber: 2,
        label: '2. ÜNİTE: SES BİLGİSİ',
        title: 'Ses Bilgisi',
        icon: '🗣️',
        description: 'Ünsüz ve Ünlü Ses Olayları',
        subTopics: [
            'Ünsüzlerle İlgili Ses Olayları',
            'Ünlülerle İlgili Ses Olayları'
        ]
    },
    {
        id: 'tur_u3',
        unitNumber: 3,
        label: '3. ÜNİTE: YAZIM KURALLARI',
        title: 'Yazım Kuralları',
        icon: '✍️',
        description: 'TDK Uyumlu Yazım Kuralları ve Doğru Kullanımlar',
        subTopics: [
            'İkilemeler ve Deyimlerin Yazılışı',
            'Pekiştirmeli Sözlerin Yazılışı',
            '"mı, mi" Soru Ekinin Yazılışı',
            '"da, de" Bağlacı ve Hâl Ekinin Yazılışı',
            '"ki" Bağlacının ve "-ki" Ekinin Yazılışı',
            'Sayıların ve Tarihlerin Yazılışı',
            'Kısaltmaların Yazılışı',
            'Büyük Harflerin Kullanımı',
            'Birleşik Sözcüklerin Yazılışı',
            'Düzeltme İşaretinin (^) Kullanımı'
        ]
    },
    {
        id: 'tur_u4',
        unitNumber: 4,
        label: '4. ÜNİTE: NOKTALAMA İŞARETLERİ',
        title: 'Noktalama İşaretleri',
        icon: '❓',
        description: 'Tüm Noktalama İşaretleri ve ÖSYM Kuralları',
        subTopics: [
            'Nokta, Virgül ve Noktalı Virgül',
            'İki Nokta ve Üç Nokta',
            'Soru ve Ünlem İşareti',
            'Kısa Çizgi ve Uzun Çizgi',
            'Tırnak ve Tek Tırnak İşareti',
            'Yay Ayraç, Köşeli Ayraç ve Kesme İşareti'
        ]
    },
    {
        id: 'tur_u5',
        unitNumber: 5,
        label: '5. ÜNİTE: ANLATIM BOZUKLUKLARI',
        title: 'Anlatım Bozuklukları',
        icon: '⚠️',
        description: 'Anlamsal ve Dil Bilgisel Anlatım Bozuklukları',
        subTopics: [
            'Anlamdan Kaynaklanan Anlatım Bozuklukları',
            'Dil Bilgisinden Kaynaklanan Anlatım Bozuklukları'
        ]
    },
    {
        id: 'tur_u6',
        unitNumber: 6,
        label: '6. ÜNİTE: SÖZCÜĞÜN VE SÖZÜN ANLAMI',
        title: 'Sözcüğün ve Sözün Anlamı',
        icon: '📖',
        description: 'Sözcük Anlamı, Anlam İlişkileri, Mecaz Yolları ve Söz Öbekleri',
        subTopics: [
            'Sözcüğün Anlam Açılımı (Gerçek, Mecaz, Terim)',
            'Sözcükler Arası Anlam İlişkileri',
            'Sözcüğe Mecaz Anlam Kazandırma Yolları',
            'Söz Öbekleri (Deyimler, Atasözleri, İkilemeler)'
        ]
    },
    {
        id: 'tur_u7',
        unitNumber: 7,
        label: '7. ÜNİTE: CÜMLENİN ANLAMI',
        title: 'Cümlenin Anlamı',
        icon: '💬',
        description: 'Cümlede Anlam İlişkileri, Cümlenin Niteliği, Boşluk Doldurma ve Kesin Yargı',
        subTopics: [
            'Anlamlarına Göre Cümleler',
            'Anlam İlişkilerine Göre Cümleler (Neden, Amaç, Koşul)',
            'Cümlenin Niteliği (Öznel - Nesnel Anlatım)',
            'Bir Duygunun, Düşüncenin, Kavramın Yer Aldığı Cümleler',
            'Cümlede Boşluk Tamamlama',
            'Cümleden Kesin Yargı Çıkarma',
            'Cümle Oluşturma'
        ]
    },
    {
        id: 'tur_u8',
        unitNumber: 8,
        label: '8. ÜNİTE: ANLATIM BİLGİLERİ',
        title: 'Anlatım Bilgileri',
        icon: '📝',
        description: 'Anlatım İlkeleri, Anlatım Biçimleri ve Düşünceyi Geliştirme Yolları',
        subTopics: [
            'Anlatım Özellikleri (Açıklık, Akıcılık, Yalınlık, Duruluk)',
            'Anlatım Biçimleri (Öyküleme, Betimleme, Açıklama, Tartışma)',
            'Düşünceyi Geliştirme Yolları (Tanımlama, Karşılaştırma, Örnekleme vb.)'
        ]
    },
    {
        id: 'tur_u9',
        unitNumber: 9,
        label: '9. ÜNİTE: PARAGRAFIN YAPISI VE ANLAMI',
        title: 'Paragrafın Yapısı ve Anlamı',
        icon: '📑',
        description: 'Paragrafta Yapı, Ana Düşünce, Yardımcı Düşünceler ve Paragraf Yorumlama',
        subTopics: [
            'Paragrafta Yapı (Akışı Bozan Cümle, Paragraf Bölme, Tamamlama)',
            'Paragrafta Ana Düşünce ve Konu',
            'Paragrafta Yardımcı Düşünceler',
            'Paragrafta Başlık ve Soruya Karşılık Olma'
        ]
    },
    {
        id: 'tur_u10',
        unitNumber: 10,
        label: '10. ÜNİTE: SÖZEL MANTIK',
        title: 'Sözel Mantık',
        icon: '🧩',
        description: 'Sözel Mantık Çözüm Taktikleri, Tablo Çizimi ve Sıralama-Grup Senaryoları',
        subTopics: [
            'Sıralama ve Mekânda Yerleştirme Senaryoları',
            'Grup ve Eşleştirme Senaryoları',
            'Üç ve Çok Bilinmeyenli Matris Senaryoları',
            'Rota, Ağ ve Karmaşık Mantık Senaryoları'
        ]
    }
];

export const ALL_TURKISH_TOPICS: string[] = TURKISH_HIERARCHY.flatMap(u => u.subTopics);
